import { ReactNode, useContext, useMemo, PropsWithChildren } from 'react'

import WizardLayout from 'components/Layout/WizardLayout'
import WizardSteps from 'components/WizardSteps'
import { NetworkWizardContext } from '../NetworkWizardContext'
import {
  NetworkWizardHeaderJobName,
  NetworkWizardHeaderJobNameWrapper,
  NetworkWizardHeaderTitle,
} from './styles'
import { useIntl } from 'react-intl'
import { network } from 'features/networkAi/messages'

interface NetworkWizardLayoutProps {
  currentWizardStepId?: number
  bottomBlock?: ReactNode
  hasError?: boolean
}

const stepsData = [
  {
    id: 1,
    title: 'Select Job / Home',
  },
  {
    id: 2,
    title: 'Purchase Subscriptions',
  },
  {
    id: 3,
    title: 'Claim Devices',
  },
  {
    id: 4,
    title: 'WLANs',
  },
]

function NetworkWizardLayout({
  currentWizardStepId,
  bottomBlock = null,
  children,
  hasError,
}: PropsWithChildren<NetworkWizardLayoutProps>) {
  const { job, isLoading, handleCloseWizard } = useContext(NetworkWizardContext)
  const { formatMessage } = useIntl()

  const headerBlock = useMemo(
    () => (
      <>
        <NetworkWizardHeaderTitle>
          {formatMessage(network.title)}
        </NetworkWizardHeaderTitle>

        {!isLoading && (
          <NetworkWizardHeaderJobNameWrapper>
            <NetworkWizardHeaderJobName>{job?.name}</NetworkWizardHeaderJobName>
          </NetworkWizardHeaderJobNameWrapper>
        )}
      </>
    ),
    [isLoading, job?.name, formatMessage]
  )

  return (
    <WizardLayout
      headerBlock={headerBlock}
      bottomBlock={bottomBlock}
      handleClose={handleCloseWizard}
    >
      {!!currentWizardStepId && (
        <WizardSteps
          stepsData={stepsData}
          currentWizardStepId={currentWizardStepId}
          hasError={hasError}
        />
      )}

      {children}
    </WizardLayout>
  )
}

export default NetworkWizardLayout
